import { render, staticRenderFns } from "./TrusteeDropdownField.vue?vue&type=template&id=3feffe67"
import script from "./TrusteeDropdownField.vue?vue&type=script&lang=ts"
export * from "./TrusteeDropdownField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3feffe67')) {
      api.createRecord('3feffe67', component.options)
    } else {
      api.reload('3feffe67', component.options)
    }
    module.hot.accept("./TrusteeDropdownField.vue?vue&type=template&id=3feffe67", function () {
      api.rerender('3feffe67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Dropdowns/TrusteeDropdownField.vue"
export default component.exports